/* Variant-aware PDP panels (Borough 22).
 *
 * product-info.js already fetches the product section rendered for a newly
 * selected variant (?variant=<id>&section_id=<id>) and publishes
 * PUB_SUB_EVENTS.variantChange with that parsed document as `html`. Every
 * element marked data-b22-variant-panel is swapped from it by id, so the
 * Description, Allergens & Ingredients and Nutrition tabs and the Thursday-only
 * notice are server rendered per variant: no duplicate markup in the page and
 * no second request. Depends on constants.js + pubsub.js (theme.liquid).
 */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var html = event && event.data && event.data.html;
    if (!html || typeof html.getElementById !== 'function') return;

    document.querySelectorAll('[data-b22-variant-panel]').forEach(function (panel) {
      var fresh = html.getElementById(panel.id);
      if (!fresh) return;
      panel.innerHTML = fresh.innerHTML;
      panel.hidden = fresh.hidden;
    });
  });
})();
